requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded('cart.js', () => {
    themeBase.onDOMContentLoadedTrigger(() => {
      if (!customElements.get('free-shipping')) {
        customElements.define(
          'free-shipping',
          class FreeShipping extends HTMLElement {
            constructor() {
              super();

              this.completedClass = 'free-shipping--completed';
            }

            connectedCallback() {
              this.cartUpdateUnsubscriber = subscribe(
                PUB_SUB_EVENTS.cartUpdate,
                this.update.bind(this)
              );

              this.quantityUpdateUnsubscriber = subscribe(
                PUB_SUB_EVENTS.quantityUpdate,
                this.update.bind(this)
              );

              if (cartBase.wasUpdate) {
                this.update();
              }
            }

            disconnectedCallback() {
              if (this.cartUpdateUnsubscriber) {
                this.cartUpdateUnsubscriber();
              }

              if (this.quantityUpdateUnsubscriber) {
                this.quantityUpdateUnsubscriber();
              }
            }

            update(event) {
              const totalPrice =
                event?.cartData?.total_price ??
                cartBase?.cartData?.total_price;

              if (totalPrice !== undefined) {
                this.changeState(totalPrice);
              } else {
                cartBase.getData().then((data) => {
                  this.changeState(data.total_price);
                });
              }
            }

            changeState(totalPrice) {
              /*
               * Cart sections can be re-rendered by Unicorn,
               * so find these elements fresh each time.
               */
              const info = this.querySelector('.free-shipping__info');
              const progressBar = this.querySelector('.free-shipping__progress-bar');
              const totalPriceElement = this.querySelector('.free-shipping__total-price');

              if (!info || !progressBar || !totalPriceElement) return;

              const freeShippingLimit = Number(window.freeShippingLimit || 6000);
              const tracked24Limit = Number(window.tracked24Limit || 20000);

              let targetLimit;
              let message;

              if (totalPrice < freeShippingLimit) {
                const leftToSpend = freeShippingLimit - totalPrice;

                targetLimit = freeShippingLimit;
               
message =
  `Spend <strong>${Shopify.formatMoney(leftToSpend, '£{{amount}}')} </strong>more for <strong>FREE UK DELIVERY</strong>`;
                this.classList.remove(this.completedClass);

              } else if (totalPrice < tracked24Limit) {
                const leftToSpend = tracked24Limit - totalPrice;

                targetLimit = tracked24Limit;
message =
  `<strong>✓ FREE UK DELIVERY</strong> — Spend <strong>${Shopify.formatMoney(leftToSpend, '£{{amount}}')} </strong>more for <strong>FREE TRACKED 24</strong>`;
                this.classList.remove(this.completedClass);

              } else {
                targetLimit = tracked24Limit;
message =
  `<strong>✓ You've qualified for FREE UK TRACKED 24 DELIVERY</strong>`;
                this.classList.add(this.completedClass);
              }

              info.innerHTML = message;

              progressBar.style.width =
                `${Math.min((totalPrice / targetLimit) * 100, 100)}%`;

              totalPriceElement.innerHTML =
                Shopify.formatMoney(totalPrice, '£{{amount}}');
            }
          }
        );
      }
    });
  });
});